import { combineReducers } from 'redux'
import { createStore, compose } from 'redux'
import { registerInNamespace } from '../application/nm'
import { getStoreConfig } from '../config/appStoreConfig'
import { registerReducer } from '../store/mountedComponents/mountedComponents.actions'
import { reducers } from '../store/reducers'

const createComposedStore = compose(...getStoreConfig())(createStore)

const appStore = createComposedStore(combineReducers(reducers))

const { subscribe, getState, dispatch } = appStore

const appStoreGetter = Object.create(appStore, {
  state: {
    get: getState,
    enumerable: true,
  },
})

registerInNamespace({ appStore: appStoreGetter })

export default appStore
export { subscribe, getState, dispatch }

export function addReducer(stateKey, reducer) {
  dispatch(registerReducer(stateKey, reducer))
  return appStore.replaceReducer(
    combineReducers({
      ...reducers,
      ...getState().mountedComponents.reducers,
    })
  )
}

export function setState(state, newState) {
  return { ...state, ...newState }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/appStore.js